import LoggerApi from '../../api/LoggerApi';
import { ProcessableRtes } from '../../C3ServerlessBundle';
import CSPS from './csps.json';

const CONTENT_SECURITY_POLICY_CONCERN_CODE = 'csp';

export default class ContentPolicyProcessor {
  isFor(concerns: string): boolean {
    return (
      concerns
        .toLowerCase()
        .split(',')
        .filter((concern) => concern === CONTENT_SECURITY_POLICY_CONCERN_CODE).length > 0
    );
  }

  process(site: string, csp) {
    const baseHeaderConfig = this.mergeCspConfigs(CSPS.core, CSPS[site]);
    const finalCspConfig = this.mergeCspConfigs(baseHeaderConfig, csp);
    const flatCspConfig = this.flattenCspConfig(finalCspConfig);
    this.addCSP(flatCspConfig);
  }

  validateClientCspValues(app, rte, csp = {}): void {
    const allValuesAreStrings = Object.values(csp).every((value) => typeof value === 'string' || value instanceof String) as boolean;
    const message =
      'You have invalid CSP. PLEASE RE-READ C3 Bundle Docs -\n https://confluence.vanguard.com/display/CCC3/C3+Serverless+solution+%3A+Integration#C3Serverlesssolution:Integration-CustomCSP(ContentSecurityPolicy)';
    console.assert(allValuesAreStrings, message);

    if (!allValuesAreStrings) {
      LoggerApi.makePostCall(rte, { level: 'error', message: `${app} pass in invalid CSP` });
      if (rte !== ProcessableRtes.ProdProcessableRte) {
        alert(message);
        throw new Error('Client Invalid CSP');
      }
    }
  }

  private mergeCspConfigs(baseHeaderConfig, clientCspConfig): any {
    if (!clientCspConfig || Object.keys(clientCspConfig).length === 0) {
      return baseHeaderConfig;
    }

    const noEmptyCspsMerged = {};
    Object.keys(baseHeaderConfig)
      .sort()
      .forEach((key) => {
        const mergedCsp = clientCspConfig[key]
          ? `${baseHeaderConfig[key]} ${clientCspConfig[key]}`.trim()
          : `${baseHeaderConfig[key]}`.trim();
        if (mergedCsp) {
          noEmptyCspsMerged[key] = mergedCsp;
        }
        delete clientCspConfig[key];
      });

    return { ...noEmptyCspsMerged, ...clientCspConfig };
  }

  private flattenCspConfig(finalCspConfig: any): string {
    return Object.keys(finalCspConfig)
      .reduce((prev, key) => {
        return `${prev} ${key} ${finalCspConfig[key]};`;
      }, '')
      .trim();
  }

  private addCSP(flattenCsp: string) {
    const metaToAdd = document.createElement('meta');
    metaToAdd.httpEquiv = 'Content-Security-Policy';
    metaToAdd.content = flattenCsp;
    document.head.appendChild(metaToAdd);
  }
}
